import { articlesFromOneData } from './mockArticlesFromOneData.ts';

export const article1 = {
  id: 'for-you-1',
  imageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_GB/homepage/images/2025/November/Inspiration-hub290x245.jpg',
  title: 'Travel Guides & Inspiration',
  body: 'Get inspired by exploring our expert travel guides, itineraries, and curated hotels. Plus, learn about the elevated benefits that eligible Cardmembers can enjoy when booking through American Express Travel.',
  ctaLabel: 'Get inspired',
  ctaDestination: 'https://www.americanexpress.com/en-gb/travel/inspiration/',
};
const article2 = {
  id: 'for-you-2',
  attribution: 'Fine Hotels + Resorts',
  imageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_GB/homepage/images/2026/February/CollegioallaQuerce.jpg',
  title: 'Fine Hotels + Resorts',
  body: 'Platinum Cardmembers receive a complimentary suite of benefits, including daily breakfast for two and guaranteed 4pm check-out, with Fine Hotels + Resorts stays booked through American Express Travel.',
  ctaLabel: 'Explore Fine Hotels + Resorts',
  ctaDestination: 'https://hotel-booking.americanexpress.com/en-gb/fhr/welcome',
};
const article3 = {
  id: 'for-you-3',
  imageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_GB/homepage/images/2026/January/Hiltonoffers.jpg',
  title: 'Pay With Points',
  body: 'At American Express Travel, eligible Cardmembers can use Membership Rewards® points for all or part of your flight, prepaid hotel, prepaid car rental or holiday bundle. Terms apply.',
  ctaLabel: 'Pay With Points',
  ctaDestination: 'https://www.americanexpress.com/uk/travel/how-to-pay-with-points/',
};
const article4 = {
  id: 'for-you-4',
  attribution: 'Grand Hotel Son Net',
  imageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/homepage/2026/April/GuestTile1.jpg',
  title: 'Preferred Hotels & Resorts',
  body: 'Enjoy a curated selection of luxurious getaways with world‑class service, and award‑winning dining in sought‑after destinations around the globe.',
  disclaimer: 'Please contact hotels directly for information on individual loyalty or reward program rules and restrictions.',
  ctaLabel: 'Explore Hotels',
  ctaDestination: 'https://hotel-booking.americanexpress.com/en-gb/fhr/welcome',
};
export const offer1 = {
  id: 'offer-1',
  hotelHref: 'https://consumer-travel-dev.americanexpress.com/en-us/travel/',
  imageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_GB/FHR-THC-Dedicated-Site/January-2026/Hero-Images/Hilton-Lake-Como_Como_Italy_8583.jpg',
  program: 'fhr',
  title: 'Caramel A Grecotel Resort',
  subtitle: 'Rethymnon, Greece',
  offerText: 'FHR Complimentary fifth night (included in avg nightly rate)',
  showTagIcon: true,
  dateConditionsText: 'Book by XX/XX/XXXX, travel by XX/XX/XXXX',
  termsDrawer: {
    buttonText: 'Terms Apply',
    body: 'Mock body text',
    tnc: {
      title: 'Terms and Conditions',
      body: 'Mock terms body text',
    },
  },
};
const offer2 = {
  id: 'offer-2',
  hotelHref: 'https://consumer-travel-dev.americanexpress.com/en-us/travel/',
  imageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/thc/images/Signia-By-Hilton-La-Cantera-Resort--Spa_80162.jpg',
  program: 'thc',
  title: 'The Grand Roma',
  subtitle: 'Rome, Italy',
  offerText: 'Enjoy a complimentary third night, plus a $X credit to apply toward eligible on-property food and beverage\n'
    + ' charges during your stay.',
  showTagIcon: true,
  dateConditionsText: 'Book by XX/XX/XXXX, travel by XX/XX/XXXX',
  termsDrawer: {
    buttonText: 'Terms Apply',
    body: 'Mock body text',
    tnc: {
      title: 'Terms and Conditions',
      body: 'Mock terms body text',
    },
  },
};
const offer3 = {
  id: 'offer-3',
  hotelHref: 'https://consumer-travel-dev.americanexpress.com/en-us/travel/',
  imageUrl: 'https://icm.aexp-static.com/Internet/travel/cttonline/en_US/thc/images/Signia-By-Hilton-La-Cantera-Resort--Spa_80162.jpg',
  program: 'thc',
  title: 'The Grand Roma',
  subtitle: 'Rome, Italy',
  offerText: 'This is a hotel without a specific offer to test that the learn more redirect link displays instead of the terms apply button.',
  showTagIcon: false,
  termsDrawer: {
    buttonText: 'Learn More',
  },
};
const ad = {
  id: 'for-you-ad',
  channelName: 'TLS',
  placementName: 'HOMEPAGE_FORYOU',
};

export const mockHeading = 'Personalized Marketing Articles';

export const mockArticleSets = {
  'Four Articles': [article1, article2, article3, article4],
  'Three Articles': [article1, article2, article3],
  'Two Articles': [article1, article2],
  'One Article': [article1],
  'With Hotel Offers': [
    offer1,
    offer2,
    { ...article1, showCtaButton: true },
    { ...article2, showCtaButton: true },
  ],
  'With one Hotel Offer': [
    offer1,
    { ...article1, showCtaButton: true },
    { ...article2, showCtaButton: true },
  ],
  'With a Hotel Offer without Terms ': [
    offer1,
    offer3,
    { ...article1, showCtaButton: true },
    { ...article2, showCtaButton: true },
  ],
  'With Filters': articlesFromOneData(true).articles,
  'With Ad': [article1, article2, ad, article4],
  'With no CTA': [
    { ...article1, ctaLabel: undefined },
    { ...article2, ctaLabel: undefined },
    { ...article3, ctaLabel: undefined },
    { ...article4, ctaLabel: undefined },
  ],
};
